import { engineComponent } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { ComponentTypes } from "../../../Components/ComponentTypes";
import { UserControls } from "./UserControls";
import { GameManager } from "../../../Managers/GameManager";
import { FreespinsActions } from "../Actions/FreespinsActions";
import { HtmlController } from "../../../HTMLComponents/HtmlController";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { FreespinsController } from "../../../GameComponents/Freespins/FreespinsController";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../../Utils/FrameTimer";
import { GameActions } from "../Actions/GameActions";
import { DataManager } from "../../../Managers/DataManager";
import { GameData } from "../Datas/GameData";
import { LimitDialog } from "../Dialogs/LimitDialog";
import { AppContext } from "../../../../Common/AppContext";

var GameModules = Communication.Game.GameModules;

@engineComponent(ComponentTypes.HtmlElement)
export class FreespinsUserControls extends UserControls {
    private _fsConfigurator: HTMLElement;
    protected _controller: FreespinsController;

    protected _userControls: HTMLElement;
    protected _userControls_supreme: HTMLElement;
    protected _afterWinDelay: FrameTimerEventEmitter;
    protected _autoplayDelay: FrameTimerEventEmitter;
    protected _backDelay: FrameTimerEventEmitter;
    protected _backButtonDelay: FrameTimerEventEmitter;
    protected _prepareNewGameRound: FrameTimerEventEmitter;
    protected _userControlsShowDelay: FrameTimerEventEmitter;

    protected _wasCalclulated: boolean = true;

    constructor(key: string = "freespins") {
        super(key);
    }

    create(node: Element): void {
        super.create(node);

        this.registerActions();

        this._afterWinDelay = CreateFrameTimer("afterWinDelay");
        this._afterWinDelay.on(FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));

        this._autoplayDelay = CreateFrameTimer("autoplayDelay");
        this._autoplayDelay.on(FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));

        this._backDelay = CreateFrameTimer("backDelay");
        this._backDelay.on(FrameTimerEvents.Complete, this.back.bind(this));

        this._backButtonDelay = CreateFrameTimer("backButtonDelay");
        this._backButtonDelay.on(FrameTimerEvents.Complete, this.backButton.bind(this));

        this._prepareNewGameRound = CreateFrameTimer("prepareNewGameRound");
        this._prepareNewGameRound.on(FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));

        this._userControlsShowDelay = CreateFrameTimer("userControlsShowDelay");
        this._userControlsShowDelay.on(FrameTimerEvents.Complete, this.userControlsShowDelay.bind(this));

        this._userControls = document.getElementById("freespinsUserControls");

        this._fsConfigurator = document.getElementById("fsConfigurator");
    }

    registerActions(): void {
        this.actions.registerActions({
            [FreespinsActions.ActionStart]: false,
            [FreespinsActions.ActionBack]: false,
            [FreespinsActions.ActionAutoplay]: false,
            [FreespinsActions.ActionAutoplayStop]: false,
            [FreespinsActions.ActionSpin]: false,
            [FreespinsActions.ActionSpinStop]: false,
            [FreespinsActions.ActionStopDice]: false,
        });
    }

    initReceived(): void {
        if (
            ModuleManager.freespinsEnabled() &&
            GameManager.freespinsResponse.freeSpins &&
            GameManager.freespinsResponse.customData.dice &&
            GameManager.freespinsResponse.customData.dice.every((v?: number) => v != null)
        ) {
            DataManager.updateDataElement(
                GameData.DataFreeSpinsRemainingCount,
                GameManager.freespinsResponse.freeSpins.remainingCount.toString(),
            );
            DataManager.updateDataElement(
                GameData.DataFreeSpinsCount,
                GameManager.freespinsResponse.freeSpins.totalCount.toString(),
            );
        }

        this._userControls_supreme = document.getElementById("userControls_supreme");

        super.initReceived();

        this._controller.initReceived();

        if (this._userControls != null) {
            // this._userControls.style.display = 'none';
        }
        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            //this._userControls.classList.add(HtmlController.DisabledClass);
        }
    }

    restoreGameRound(): void {
        this.prepareNewGameRound();
    }

    dispatchAction(action: string): void {
        if (action === GameActions.ActionSpinOrStop) {
            if (this.actions.getActionState(FreespinsActions.ActionStart)) {
                action = FreespinsActions.ActionStart;
            } else if (this.actions.getActionState(FreespinsActions.ActionBack)) {
                action = FreespinsActions.ActionBack;
            } else if (this.actions.getActionState(FreespinsActions.ActionSpin)) {
                action = FreespinsActions.ActionSpin;
            } else if (this.actions.getActionState(FreespinsActions.ActionSpinStop)) {
                action = FreespinsActions.ActionSpinStop;
            } else {
                return;
            }
        }

        if (this.actions.getActionState(action)) {
            super.dispatchAction(action);

            switch (action) {
                case FreespinsActions.ActionStart:
                    this.start();
                    break;
                case FreespinsActions.ActionBack:
                    this.back();
                    break;
                case FreespinsActions.ActionSpin:
                    this.spin();
                    break;
                case FreespinsActions.ActionSpinStop:
                    this.stop();
                    break;
                case FreespinsActions.ActionAutoplay:
                    this.autoplay();
                    break;
                case FreespinsActions.ActionAutoplayStop:
                    this.autoplayStop();
                    break;
            }
        }
    }

    start(id?: number): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
        this._controller.start(id);
    }

    startReceived(allDone: boolean): void {
        ModuleManager.outroModule(GameModules.Base);

        //all dice thrown. We know exact number of freespins
        // if (GameManager.freespinsResponse.freeSpins
        //     && GameManager.freespinsResponse.customData.dice
        //     && GameManager.freespinsResponse.customData.dice.every((v?: number) => v != null)
        // ) {
        //     DataManager.updateDataElement(GameData.DataFreeSpinsRemainingCount, GameManager.freespinsResponse.freeSpins.remainingCount.toString());
        //     DataManager.updateDataElement(GameData.DataFreeSpinsCount, (GameManager.freespinsResponse.freeSpins.totalCount).toString());
        // }
        //
        // this.diceApply();
        // if(allDone) {
        //     this._userControls.classList.remove(HtmlController.DisabledClass);
        //     this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        //
        //     ModuleManager.outroModule(GameModules.Base);
        // } else {
        //     this.actions.changeActionState(FreespinsActions.ActionStopDice, true);
        //     HtmlController.updateActionElement(FreespinsActions.ActionStopDice, true);
        // }
    }

    spin(): void {
        if (!this._wasCalclulated) {
            if (GameManager.freespinsResponse != null && GameManager.freespinsResponse.currentWin > 0) {
                Platforms.Platforms.win(GameManager.freespinsResponse.currentWin);
            }
        }

        DataManager.updateDataElement(
            GameData.DataFreeSpinsRemainingCount,
            (GameManager.freespinsResponse.freeSpins.remainingCount - 1).toString(),
        );

        this.actions.disableAllActions();
        if (DataManager.Autoplay) {
            this.actions.changeActionState(FreespinsActions.ActionAutoplayStop, DataManager.autoplayEnabled());
        }
        HtmlController.dispatchUiAction("");
        DataManager.updateDataElement(GameData.DataTotalWin);
        HtmlController.updateActionElements(this.getAllActions());
        this._controller.spin();

        Platforms.Platforms.spinStarted();
    }

    spinReceived(): void {
        if (DataManager.quickspinEnabled()) {
            // auto quick stop
            this.actions.changeActionState(FreespinsActions.ActionSpinStop, false);
            HtmlController.updateActionElements(this.getAllActions());
            HtmlController.dispatchUiAction("");
            this._controller.stop();
        } else {
            this.actions.changeActionState(
                FreespinsActions.ActionSpinStop,
                AppContext.gameConfiguration.GameEnableReelsStop,
            );
            HtmlController.updateActionElements(this.getAllActions());
        }
    }

    back(): void {
        this._backDelay.stop();
        this.disable();
        ModuleManager.endFreespins();
    }

    stop(): void {
        this.actions.changeActionState(FreespinsActions.ActionSpinStop, false);
        HtmlController.updateActionElements(this.getAllActions());
        HtmlController.dispatchUiAction("");
        DataManager.quickspinStopped();
        this._controller.stop();
    }

    end(): void {
        if (GameManager.freespinsResponse != null && GameManager.freespinsResponse.totalWin > 0) {
            Platforms.Platforms.win(GameManager.freespinsResponse.totalWin, true);
        }

        this._controller.end();
    }

    endReceived(): void {
        ModuleManager.outroModule(GameModules.Freespins);
    }

    autoplayDelayed(): void {
        this._autoplayDelay.stop();
        if (DataManager.Autoplay) {
            this.autoplay();
        } else {
            this.prepareNewGameRound();
        }
    }

    autoplay(): void {
        this._afterWinDelay.stop();

        if (DataManager.AutoplayCount === "∞") {
            DataManager.Autoplay = true;
            DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);
            this.spin();
        } else {
            DataManager.AutoplayCount = (parseInt(DataManager.AutoplayCount) - 1).toString();
            if (parseInt(DataManager.AutoplayCount) >= 0) {
                DataManager.Autoplay = true;
                DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);
                this.spin();
            } else {
                DataManager.Autoplay = false;
                this.prepareNewGameRound();
            }
        }
    }

    autoplayStop(): void {
        DataManager.Autoplay = false;
        this.actions.changeActionState(FreespinsActions.ActionAutoplayStop, false);
        HtmlController.updateActionElement(FreespinsActions.ActionAutoplayStop, false);
    }

    backButton(): void {
        this.actions.changeActionState(FreespinsActions.ActionBack, true);
        HtmlController.updateActionElement(FreespinsActions.ActionBack, true);
    }

    enable(): void {
        DataManager.updateDataElement(
            GameData.DataFreeSpinsRemainingCount,
            GameManager.freespinsResponse.freeSpins.remainingCount.toString(),
        );
        DataManager.updateDataElement(
            GameData.DataFreeSpinsCount,
            GameManager.freespinsResponse.freeSpins.totalCount.toString(),
        );

        this.actions.changeActionState(FreespinsActions.ActionStart, false);
        HtmlController.updateActionElement(FreespinsActions.ActionStart, false);

        this._controller.enable();
    }

    disable(): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
    }

    prepareNewGameRound(): void {
        this._afterWinDelay.stop();

        if (GameManager.freespinsResponse.totalWin != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinTotalWin,
                GameManager.freespinsResponse.totalWin.toString(),
            );
        }
        DataManager.updateDataElement(GameData.DataFreeSpinTotalWin);

        if (DataManager.GameLimit) {
            DataManager.Autoplay = false;
            this.limit();
        } else {
            if (!DataManager.Autoplay) {
                this.actions.changeActionStates({
                    [FreespinsActions.ActionStart]: false,
                    [FreespinsActions.ActionBack]: false,
                    [FreespinsActions.ActionAutoplay]: !DataManager.Autoplay && DataManager.autoplayEnabled(),
                    [FreespinsActions.ActionAutoplayStop]: DataManager.Autoplay && DataManager.autoplayEnabled(),
                    [FreespinsActions.ActionSpin]: true,
                    [FreespinsActions.ActionSpinStop]: false,
                });
            }
        }
        HtmlController.updateActionElements(this.getAllActions());
    }

    limit(): void {
        LimitDialog.openDialog();

        this.actions.changeActionStates({
            [FreespinsActions.ActionStart]: false,
            [FreespinsActions.ActionBack]: false,
            [FreespinsActions.ActionAutoplay]: false,
            [FreespinsActions.ActionAutoplayStop]: false,
            [FreespinsActions.ActionSpin]: false,
            [FreespinsActions.ActionSpinStop]: false,
        });
    }

    addController(controller: FreespinsController): void {
        this._controller = controller;
        this._controller.on(FreespinsController.ConfiguratorStart, this.configuratorStart.bind(this));
    }

    configuratorStart(): void {}

    hideConfigurator(): void {}

    /**
     *
     * @returns {boolean}
     */
    isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            this.limit();
            return true;
        }

        if (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        ) {
            return true;
        }

        return false;
    }

    winCalculationFinished(): void {
        this._afterWinDelay.stop();

        DataManager.updateDataElement(GameData.DataTotalWin);

        if (GameManager.freespinsResponse.totalWin != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinTotalWin,
                GameManager.freespinsResponse.totalWin.toString(),
            );
        }
        DataManager.updateDataElement(GameData.DataFreeSpinTotalWin);

        if (this.isLastFreespin()) {
            DataManager.Autoplay = false;
            this.actions.disableAllActions();
            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.prepareNewGameRound();
    }

    allWinsFinished(): void {
        if (GameManager.freespinsResponse != null && GameManager.freespinsResponse.currentWin > 0) {
            Platforms.Platforms.win(GameManager.freespinsResponse.currentWin);
        }

        this._wasCalclulated = true;

        this._afterWinDelay.stop();

        if (this.isLastFreespin()) {
            DataManager.Autoplay = false;
            this.actions.disableAllActions();

            this._backButtonDelay.start(120);

            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.prepareNewGameRound();
        if (DataManager.Autoplay) {
            this.autoplay();
        }
    }

    /* ********************************************************************
     * INTRO/OUTRO
     * ********************************************************************/

    initIntro(): void {
        DataManager.updateDataElement(
            GameData.DataFreeSpinsRemainingCount,
            GameManager.freespinsResponse.freeSpins.remainingCount.toString(),
        );

        DataManager.updateDataElement(GameData.DataTotalWin);

        if (GameManager.freespinsResponse.totalWin != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinTotalWin,
                GameManager.freespinsResponse.totalWin.toString(),
            );
        }
        DataManager.updateDataElement(GameData.DataFreeSpinTotalWin);

        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }
        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }

        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            //ToDo je potrebne kontrolovat contains ?
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }
        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }

        super.initIntro();
        this._controller.initIntro();
        Platforms.Platforms.featureInit({ type: Communication.Game.GameModules.Freespins });

        if (this.isLastFreespin()) {
            this.actions.disableAllActions();

            this._backButtonDelay.start(60);

            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.prepareNewGameRound();
    }

    intro(long: boolean = false): void {
        this.hideConfigurator();
        this._controller.intro(long);
    }

    introFinished(): void {
        this._prepareNewGameRound.start(60);
        this._userControlsShowDelay.start(100);

        /*
        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }

        if (this._userControls_supreme != null && this._userControls_supreme.classList.contains(HtmlController.DisabledClass)) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }
        */
    }

    outro(): void {
        DataManager.Autoplay = false;

        this._controller.outro();

        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }

        if (
            this._userControls_supreme != null &&
            !this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.add(HtmlController.DisabledClass);
        }
    }

    outroFinished(): void {
        this._userControls.classList.add(HtmlController.DisabledClass);
        ModuleManager.introModule(GameModules.Base, true);
    }

    freeSpinsStartButton(): void {
        this.actions.changeActionState(FreespinsActions.ActionStart, true);
        HtmlController.updateActionElement(FreespinsActions.ActionStart, true);
    }

    userControlsShowDelay(): void {
        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }

        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/UserControls/FreespinsUserControls.ts
 **/